function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M9.99998 4V8",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = React.createElement("path", {
  d: "M22 4V8",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = React.createElement("path", {
  d: "M11.3333 15.3332H10",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = React.createElement("path", {
  d: "M11.3333 20.0002H10",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = React.createElement("path", {
  d: "M28 12.3944V10C28 7.79086 26.2091 6 24 6H8C5.79086 6 4 7.79086 4 10V24C4 26.2091 5.79086 28 8 28H12.4488",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = React.createElement("path", {
  d: "M22.6667 29.3333C18.9853 29.3333 16 26.348 16 22.6667C16 18.9853 18.9853 16 22.6667 16C26.3493 16 29.3333 18.9853 29.3333 22.6667C29.3333 26.348 26.3493 29.3333 22.6667 29.3333",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = React.createElement("path", {
  d: "M24.2411 24.2413L22.0484 22.9045V19.856",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgScheduleClock = function SvgScheduleClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgScheduleClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/schedule-clock.7e544cc7.svg";
export { ForwardRef as ReactComponent };